import React from 'react';
import PropTypes from 'prop-types';
import SubscriptionHubWarning from '../../common/SubscriptionHubWarning';
import withRouter from '../../../withRouter';

/**
 * Composant pour le tunnel de redirection vers le portail Assurance Vie (MMA ou Primonial)
 * Utilise le composant générique SubscriptionHubWarning
 */
const LifeInsuranceHubWarning = ({ navigate, location, params }) => {
    const { contractType } = params;

    // Détermination de la clé de configuration selon le type de souscription
    const hubConfigKey = contractType.toLowerCase().includes('mma') ? 'LIFE_INSURANCE_MMA' : 'LIFE_INSURANCE_PRIMONIAL';

    return (
        <SubscriptionHubWarning
            hubConfigKey={hubConfigKey}
            location={location}
            params={params}
            navigate={navigate}
        />
    );
};

LifeInsuranceHubWarning.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
        contractId: PropTypes.string,
        contractType: PropTypes.string,
    }),
    navigate: PropTypes.shape({}),
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
};

export default withRouter(LifeInsuranceHubWarning);
